import { defineComponent as _defineComponent } from 'vue'
import { computed, useAttrs } from '@nuxtjs/composition-api';
import { BravadoButtonV3Size } from './types';
import SpinnerIcon from '~/components/common/BravadoButtonV3/images/spinner.vue.svg';

type BravadoButtonV3Type = 'a' | 'button' | 'NuxtLink';
type BravadoButtonV3Variant = 'accent' | 'primary' | 'secondary' | 'danger' | 'blank' | 'border';
type BravadoButtonV3Props = {
  size?: BravadoButtonV3Size;
  variant?: BravadoButtonV3Variant;
  isIconButton?: boolean;
  isSoftDisabled?: boolean;
  elevated?: boolean;
  loading?: boolean;
  fullWidth?: boolean;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'BravadoButtonV3',
  props: {
    size: { default: BravadoButtonV3Size.md },
    variant: { default: 'accent' },
    isIconButton: { type: Boolean, default: false },
    isSoftDisabled: { type: Boolean, default: false },
    elevated: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    fullWidth: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { size: BravadoButtonV3Size, variant: BravadoButtonV3Variant, isIconButton: boolean, isSoftDisabled: boolean, elevated: boolean, loading: boolean, fullWidth: boolean };



const componentType = computed<BravadoButtonV3Type>(() => {
  const { href, to, disabled } = useAttrs();

  if (href && !disabled) return 'a';
  if (to && !disabled) return 'NuxtLink';
  return 'button';
});

const rootClass = computed(() => {
  return {
    'bravado-button-v3': true,
    [`bravado-button-v3--${props.size}`]: true,
    [`bravado-button-v3--${props.variant}`]: true,
    'bravado-button-v3--icon': props.isIconButton,
    'bravado-button-v3--soft-disabled': props.isSoftDisabled,
    'bravado-button-v3--elevated': props.elevated,
    'bravado-button-v3--loading': props.loading,
    'bravado-button-v3--full-width': props.fullWidth,
  };
});

const iconSize = computed(() => {
  if (props.size === BravadoButtonV3Size.xs) return 16;
  if (props.size === BravadoButtonV3Size.sm) return 20;
  return 24;
});

return { __sfc: true,props, componentType, rootClass, iconSize, SpinnerIcon }
}

})